module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_question-1afb0dbb87b54076a294d92aa8e98a1b.svg";